// extracted by mini-css-extract-plugin
export var button = "_66-4";
export var hasDarkBackground = "_66-7";
export var hasLightBackground = "_66-6";
export var iconWrapper = "_66-0";
export var large = "_66-2";
export var medium = "_66-1";
export var small = "_66-5";
export var xsmall = "_66-3";